"use client";
import { useEffect, useState } from "react";

let idSeq = 0;

export default function ToastCenter() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const onShow = (e) => {
      const detail = e?.detail;
      const payload =
        typeof detail === "string" ? { message: detail } : detail || {};
      const {
        message = "",
        intent = "info",
        action,
        durationMs = 4000,
      } = payload;
      if (!message && !action) return;
      const id = ++idSeq;
      setToasts((t) => [...t, { id, message, intent, action }]);
      // Auto-dismiss unless an action keeps the toast available.
      if (!action) {
        const timeoutMs = Number.isFinite(Number(durationMs))
          ? Math.max(0, Number(durationMs))
          : 4000;
        setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), timeoutMs);
      }
    };
    const onHide = (e) => {
      const { id } = e.detail || {};
      setToasts((t) => (id ? t.filter((x) => x.id !== id) : []));
    };
    window.addEventListener("toast:show", onShow);
    window.addEventListener("toast:hide", onHide);
    return () => {
      window.removeEventListener("toast:show", onShow);
      window.removeEventListener("toast:hide", onHide);
    };
  }, []);

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-20 z-[80] flex flex-col items-center gap-2 px-4">
      {toasts.map((t) => (
        <div
          key={t.id}
          className="pointer-events-auto rounded-[var(--radius)] border border-[var(--border)] bg-[var(--card)]/90 backdrop-blur px-3 py-2 shadow-md flex items-center gap-3"
          role="status"
        >
          <span
            className={{
              info: "text-[var(--fg-secondary)]",
              success: "text-[var(--success)]",
              error: "text-[var(--danger)]",
              warning: "text-[var(--warning)]",
            }[t.intent || "info"]}
          >
            ●
          </span>
          <span className="text-sm">{t.message}</span>
          {t.action ? (
            <button
              className="ml-2 text-sm font-medium text-[var(--brand)] underline decoration-dotted underline-offset-2"
              onClick={() => {
                try { t.action?.(); } finally {
                  window.dispatchEvent(new CustomEvent("toast:hide", { detail: { id: t.id } }));
                }
              }}
            >
              View
            </button>
          ) : null}
        </div>
      ))}
    </div>
  );
}

// helper to fire toasts from anywhere
export function showToast(detail) {
  window.dispatchEvent(new CustomEvent("toast:show", { detail }));
}
